const __typename = 'spendPrefundAmount'

const spendPrefundAmountDefault = {
  spendPrefundAmount: {
    __typename,
    value: null,
  },
}

export default function updateSpendPrefundAmount(_, input, { cache }) {
  const {
    input: { value },
  } = input
  const data = {
    spendPrefundAmount: {
      __typename,
      value,
    },
  }

  cache.writeData({ data })
  return data
}

export { spendPrefundAmountDefault }
